import { createSlice } from '@reduxjs/toolkit';

const FJLoadingModalSlice = createSlice({
    name: 'loadingModal',
    initialState: {
        isShow: false,
        message: '',
        isCancel: false,
        onlyLoading: false,
    },
    reducers: {
        setMessage: (state, action) => {
            state.message = action.payload;
        },
        setIsShow: (state, action) => {
            state.isShow = action.payload;
        },
        setIsCancel: (state, action) => {
            state.isCancel = action.payload;
        },
        setOnlyLoading: (state, action) => {
            state.onlyLoading = action.payload;
        },
    },
});

export default FJLoadingModalSlice;
